import React from "react";
import { TertiaryButton } from "components";
import { MdClose } from "react-icons/md";
import { HeaderTextColor } from "utils";
// Hooks
import { useOutside } from "hooks";
import "./styles.scss";
export const Modal = (props) => {
  const modalRef = React.createRef(null);

  useOutside(modalRef, props.onClose, props.show);

  React.useEffect(() => {
    const body = document.querySelector("body");
    if (props.show) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "auto";
    }
  }, [props.show]);
  return (
    <div className="modal__container" hidden={!props.show}>
      <div className="modal__content" ref={modalRef}>
        <div className="modal__header">
          <HeaderTextColor modifiers={["h3"]}>
            {props.title ? props.title : "Modal"}
          </HeaderTextColor>
          <div className="modal__close" onClick={props.onClose}>
            <MdClose />
          </div>
        </div>
        <div className="modal__body">{props.children}</div>
        <div className="modal__footer">
          <TertiaryButton
            modifiers={["small", "autoWidth"]}
            onClick={props.onClose}
          >
            Cerrar
          </TertiaryButton>
          {props.onConfirm}
        </div>
      </div>
    </div>
  );
};
